import React from 'react';

interface LightModeWrapperProps {
  children: React.ReactNode;
  className?: string;
}

const LightModeWrapper: React.FC<LightModeWrapperProps> = ({ children, className = '' }) => {
  return (
    <div className={`light ${className}`} data-theme="light">
      <style>{`
        .light,
        .light * {
          color-scheme: light !important;
        }
        .light .dark\\:bg-gray-800 {
          background-color: white !important;
        }
        .light .dark\\:bg-gray-900 {
          background-color: #f9fafb !important;
        }
        .light .dark\\:text-white {
          color: #111827 !important;
        }
        .light .dark\\:text-gray-100 {
          color: #111827 !important;
        }
        .light .dark\\:text-gray-200 {
          color: #374151 !important;
        }
        .light .dark\\:text-gray-300 {
          color: #4b5563 !important;
        }
        .light .dark\\:text-gray-400 {
          color: #6b7280 !important;
        }
        .light .dark\\:border-gray-600 {
          border-color: #d1d5db !important;
        }
        .light .dark\\:border-gray-700 {
          border-color: #e5e7eb !important;
        }
        .light .dark\\:border-gray-800 {
          border-color: #f3f4f6 !important;
        }
        .light .dark\\:bg-gray-700 {
          background-color: #f9fafb !important;
        }
        .light .dark\\:bg-gray-600 {
          background-color: #f3f4f6 !important;
        }
        .light .dark\\:border-gray-600 {
          border-color: #e5e7eb !important;
        }
        .light .dark\\:border-gray-500 {
          border-color: #d1d5db !important;
        }
        .light input,
        .light textarea,
        .light select {
          background-color: white !important;
          color: #111827 !important;
          border-color: #d1d5db !important;
        }
        .light input:focus,
        .light textarea:focus,
        .light select:focus {
          border-color: #3b82f6 !important;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1) !important;
        }
        .light button {
          color: inherit !important;
        }
        .light button.bg-primary-600,
        .light .bg-primary-600 {
          background-color: #0f7f75 !important;
          color: white !important;
        }
        .light button.hover\\:bg-primary-700:hover,
        .light .hover\\:bg-primary-700:hover {
          background-color: #4338ca !important;
        }
        .light button[type="submit"] {
          background-color: #0f7f75 !important;
          color: white !important;
        }
        .light button[type="submit"]:hover {
          background-color: #4338ca !important;
        }
        /* Form actions area */
        .light .bg-gray-50 {
          background-color: #f9fafb !important;
        }
        .light .border-gray-200 {
          border-color: #e5e7eb !important;
        }
      `}</style>
      {children}
    </div>
  );
};

export default LightModeWrapper;
